var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'badge-container-'+_vm.size},[_c('div',{staticClass:"badge",class:_vm.badgeClass,style:(_vm.badgeStyle)},[_vm._v(" "+_vm._s(_vm.letter)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }